import React, { useState, useEffect, useCallback} from 'react';
import { collection, doc, setDoc, query, where, get, getDoc, getDocs, onSnapshot, updateDoc } from "firebase/firestore";
import { db } from '../../firebase-config.js'
import firebase from 'firebase/compat/app';
import 'firebase/firestore';
import '../PetList.css'
import Browse from '../Browse';
import NavbarBrowse from '../../components/NavbarBrowse';
//import Cards from '../Cards';
import Search from '../Search';
import PetList from '../PetList';

import { useGetAllPetBreeds, useShelters, useSheltersTest } from '../../context/BrowseContext';
import { useOwners } from '../../context/OwnersContext';
import AddAccountsUtility from '../AddAccountsUtility.jsx';

import { testAccounts } from "../../models/accounts.test.data";
import { testPets } from "../../models/pets.test.data";
import { Account } from "../../models/Account.model";
import { Shelter } from "../../models/Shelter.model";
import { User } from "../../models/User.model";
import { ContactInfo } from "../../models/ContactInfo.model";
import { Pet } from "../../models/Pet.model";


const buildAccountModels = (fireAccounts) => {
  
  const filteredAccounts = fireAccounts.filter(a => a.type === "Shelter");
  
  const accountModels = filteredAccounts.map((acc) => {
    const newAccount = new Account();
    const newUser = new User();
    const newContactInfo = new ContactInfo();
    const newShelter = new Shelter();

    newAccount.type = acc.type;
    //newAccount.id = acc.id;
    newAccount.Owner = undefined;

    newShelter.name = acc.shelter.name;
    //newShelter.logoImgUrl = acc.shelter.logoImgUrl;
    newShelter.website = acc.shelter.website;

    newContactInfo.phoneNumber = acc.contactInfo.phoneNumber; 
    newContactInfo.email = acc.contactInfo.email; 
    newContactInfo.city = acc.contactInfo.city; 
    newContactInfo.street = acc.contactInfo.street; 
    newContactInfo.state = acc.contactInfo.state; 
    newContactInfo.zipCode = acc.contactInfo.zipCode; 

    newUser.userID = acc.user.userID;
    newUser.email = acc.user.email;
    newUser.userName = acc.user.userName;

    newAccount.user = newUser;
    newAccount.ContactInfo = newContactInfo;
    newAccount.Shelter = newShelter;
    
    return newAccount;
  });
  
  return accountModels;
} 

const buildPetModels = (firePets) => {
  const petModels = firePets.map((p) => {
    const newPet = new Pet();
    newPet.id = p.id
    newPet.shelterID = p.shelterID;
    newPet.name = p.name;
    newPet.species = p.species;
    newPet.breed = p.breed;
    newPet.disposition = p.disposition;
    newPet.description = p.description;
    newPet.availability = p.availability;
    newPet.age = p.age;
    newPet.petImgUrl = p.imgUrl;
    return newPet;
  });
  return petModels;
};

function Home() {
  const [pets, setPets] = useState([]);
  const [searchedPets, setSearchedPets] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [isSearch, setIsSearch] = useState(false);
  
  const [shelters, setShelters] = useState({});
  

  useEffect(() => {
    let unsubscribed = false;
  
    getDocs(collection(db, "accounts"))
      .then((querySnapshot) => {
        if (unsubscribed) return; // unsubscribed? do nothing.
        
        const newUserDataArray = querySnapshot.docs
          .map((doc) => ({ ...doc.data(), id: doc.id }));
        
        const newAccountModels = buildAccountModels(newUserDataArray);
        
        setShelters(newAccountModels);
        console.log(newAccountModels)
      })
      .catch((err) => {
        if (unsubscribed) return; // unsubscribed? do nothing.
  
        // TODO: Handle errors
        console.error("Failed to retrieve data", err);
      });
  
    return () => unsubscribed  = true;
  }, []);

  useEffect(() => {
    let unsubscribed = false;
  
    getDocs(collection(db, "pets"))
      .then((querySnapshot) => {
        if (unsubscribed) return; // unsubscribed? do nothing.
        
        const newPetArray = querySnapshot.docs
          .map((doc) => ({ ...doc.data(), id: doc.id }));
        
        const newPetModels = buildPetModels(newPetArray);
        setPets(newPetModels);
        //setPets(newPetArray);
      })
      .catch((err) => {
        if (unsubscribed) return; // unsubscribed? do nothing.
  
        // TODO: Handle errors
        console.error("Failed to retrieve data", err);
      });
  
    return () => unsubscribed  = true;
  }, []);
    
  const testLog = () => {
    console.log(shelters)
    console.log(pets)
  }


  const handleSearch = async (e, values) =>  {
    e.preventDefault();
    const newSearchedPets = pets.filter((pet) => {
      if(pet.breed === values.dogBreed || pet.breed === values.catBreed || pet.disposition === values.disposition)
        return true;
      else
        return false;
    });
    setIsSearch(true);
    setSearchedPets([...newSearchedPets]);  
  };

  const handleResetSearchedArray = () => {
    setIsSearch(false);
    setSearchedPets([]); 
  };

  const updatePetAvailability = async (pet) => {
    const petsRef = doc(db, "pets", pet)
    await updateDoc(petsRef, {
      "availability" : "pending",
    })
    .then(Response=> {
      console.log(Response.id)
    })
    .catch(error =>
      console.log(error.message))
  };

  const handleAdoption = (e, petID) => {
    e.preventDefault();
    //const adoptedPet = pets.filter((p) => p.id === petID );
    //adoptedPet.availability = "Adopted";
    //console.log(adoptedPet)
    updatePetAvailability(petID);  // Call api and update animal
    const newPetList = pets.filter((p) => p.id !== petID);
    setPets([...newPetList]);
    alert("Please reach out to us to complete your adoption!");
  };
  
// =======
//   return (
//     <div>
//       {/* {set()} */}
//       <NavbarBrowse />
//       <Browse />
//       <p>text</p>
//       <button className='form-input-btn' onClick={set} >submit</button>
//       <button className='form-input-btn' onClick={getShelter
//       } >retrieve</button>
// >>>>>>> master

  const logPets = () => {
    console.log(pets);
  }
  
  return (
    <div>
      <NavbarBrowse />
      <Search handleSearch={handleSearch} handleResetSearchedArray={handleResetSearchedArray} />
      {<PetList handleAdoption={handleAdoption} pets={isSearch ? searchedPets : pets} shelters={shelters} />}
      {/* <button onClick={testLog} className="log-button">
        log searched pets
      </button> */}
      {/* <PetList pets={pets} /> */}
      {/* <AddAccountsUtility /> */}
    </div>
  );
}

export default Home